<template>
  <v-container fluid v-if="job">
    <v-row>
      <v-col cols="12">
        <h1 class="title">BoxBrownie - Job</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-list dense>
          <v-list-item>
            <v-list-item-content>Nom du job:</v-list-item-content>
            <v-list-item-content class="align-end">{{ job.jobTitle }}</v-list-item-content>
          </v-list-item>
          <v-list-item v-if="job.jobDateSubmitted">
            <v-list-item-content>Date de soumission:</v-list-item-content>
            <v-list-item-content class="align-end">{{ job.jobDateSubmitted }}</v-list-item-content>
          </v-list-item>
          <v-list-item v-if="job.jobDateDue">
            <v-list-item-content>Date de livraison due:</v-list-item-content>
            <v-list-item-content class="align-end">{{ job.jobDateDue }}</v-list-item-content>
          </v-list-item>
          <v-list-item v-if="job.jobDateComplete">
            <v-list-item-content>Date de livraison:</v-list-item-content>
            <v-list-item-content class="align-end">{{ job.jobDateComplete }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>Status:</v-list-item-content>
            <v-list-item-content class="align-end">{{ job.jobStatus }}</v-list-item-content>
          </v-list-item>
          <v-list-item v-if="job.jobEditCount">
            <v-list-item-content>Nombre de modifications:</v-list-item-content>
            <v-list-item-content class="align-end">{{ job.jobEditCount }}</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h1 class="title">Images</h1>
      </v-col>
    </v-row>
    <v-row v-if="images && images.payable">
      <v-col cols="12">
        <v-card class="elevation-0">
          <v-card-title class="subtitle-2">Image à modifier</v-card-title>
          <v-card-text>
            <template v-for="(image,index) in images.payable">
              <file-upload v-model="images.payable[index]" :key=image.id @uploaded="shiftImage(image.id, images.payable[index])" />
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="images && images.payable">
      <v-col cols="12">
        <v-card class="elevation-0">
          <v-card-title class="subtitle-2">Images de références</v-card-title>
          <v-card-text>
            <template v-for="(image,index) in images.notPayable">
              <file-upload v-model="images.notPayable[index]" :key=image.id />
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h1 class="title">Job Detail</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-0">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="addEditDialog" max-width="450px" v-if="job.jobStatus=='prepared'">
              <template v-slot:activator="{on}">
                <v-btn v-on="on">Ajouter une ligne</v-btn>
              </template>
              <v-card>
                <v-card-title>Ajouter un ligne</v-card-title>
                <v-card-text>
                  <v-select :items="editsList" item-text="name" item-value="id" v-model="newLine"></v-select>
                </v-card-text>
                <v-card-actions>
                  <v-btn text @click="addEditDialog=false">Annuler</v-btn>
                  <v-spacer />
                  <v-btn @click="submitAddEdit()">Ajouter</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
          <v-card-text>
            <v-expansion-panels accordion multiple>
              <template v-for="edit in job.edits">
                <v-expansion-panel :key="edit.id">
                  <v-expansion-panel-header>
                    <v-row no-gutters align-content="center">
                      <v-col cols="11" align-self="center">{{edit.edit.name}}</v-col>
                      <v-col cols="1" v-if="job.jobStatus=='prepared'">
                        <v-dialog
                          v-model="addOptionDialog[edit.id]"
                          v-if="hasOptions(edit.edit.id)"
                          max-width="450px"
                        >
                          <template v-slot:activator="{on}">
                            <v-btn icon class="ma-0" v-on="on">
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title>Ajouter une option</v-card-title>
                            <v-card-text>
                              <v-select
                                :items="getOptions(edit.edit.id)"
                                item-text="name"
                                item-value="id"
                                v-model="newOption"
                                :return-object="true"
                              ></v-select>
                              <v-select
                                v-if="optionValues"
                                :items="optionValues"
                                item-text="value"
                                item-value="id"
                                v-model="newOptionValue"
                              ></v-select>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn text @click="addOptionDialog[edit.id]=false">Annuler</v-btn>
                              <v-spacer />
                              <v-btn @click="submitAddOption(edit)">Ajouter</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-dialog v-model="deleteDialog[edit.id]" max-width="340">
                          <template v-slot:activator="{on}">
                            <v-btn icon class="ma-0" v-on="on">
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title>Effacer un edit</v-card-title>
                            <v-card-text>Etes-vous sûr de vouloir effacer cet 'edit' et toutes ses options ?</v-card-text>
                            <v-card-actions>
                              <v-btn text @click="deleteDialog[edit.id]=false">Annuler</v-btn>
                              <v-spacer />
                              <v-btn @click="submitDelete(edit)">Effacer</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <template v-for="option in edit.options">
                      <v-row :key="option.id">
                        <v-col cols="5" class="subtitle-2">{{option.option.name}}</v-col>
                        <v-col cols="6">{{option.value.value}}</v-col>
                        <v-col cols="1" v-if="job.jobStatus=='prepared'">
                          <v-btn icon>
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon>
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </template>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
            </v-expansion-panels>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="elevation-0">
          <v-card-title>
            <v-spacer />
            <v-dialog v-if="job.jobStatus=='prepared'" v-model="confirmSent" max-width="240px">
              <template v-slot:activator="{on}">
                <v-btn v-on="on" class="primary">Envoyer le job à BoxBrownie</v-btn>
              </template>
              <v-card>
                <v-card-title>Etes-vous sûre ?</v-card-title>
                <v-card-text>L'ordre sera envoyée à BoxBrownie et ne pourra pas être annuler</v-card-text>
                <v-card-actions>
                  <v-btn text @click="confirmSent=false">Annuler</v-btn>
                  <v-spacer />
                  <v-btn @click="submitSent()" class="primary">Confirmer</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-if="order.status=='toBeReviewed'"
              v-model="confirmValidate"
              max-width="240px"
            >
              <template v-slot:activator="{on}">
                <v-btn v-on="on" class="primary">Valider le travail et envoyer au client</v-btn>
              </template>
              <v-card>
                <v-card-title>Etes-vous sûre ?</v-card-title>
                <v-card-text>La commande sera envoyée au client</v-card-text>
                <v-card-actions>
                  <v-btn text @click="confirmValidate=false">Annuler</v-btn>
                  <v-spacer />
                  <v-btn @click="submitValidate()" class="primary">Confirmer</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ASSET_DOMAIN } from "../../common/config-local";
import FileUpload from "@/components/FileUpload.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components:{
    FileUpload
  },
  props: {
    order: {
      type: Object,
      require: true
    }
  },
  data: function() {
    return {
      job: null,
      deleteDialog: {},
      addEditDialog: null,
      newLine: null,
      addOptionDialog: {},
      newOption: null,
      optionValues: null,
      newOptionValue: null,
      confirmSent: null,
      confirmValidate: null,
      images:[],
      newImage:null
    };
  },
  watch: {
    newOption: function(value) {
      if (value && value.values && value.values.length > 0) {
        this.optionValues = value.values;
      } else {
        this.optionValues = null;
      }
    }
  },
  computed: {
    ...mapGetters("bbjob", ["editsList"])
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions("bbjob", [
      "deleteEdit",
      "getEditsList",
      "addEdit",
      "addOption",
      "sent"
    ]),
    ...mapActions("order", ["confirm", "getImages", "changeImage"]),
    initialize() {
      this.$store.dispatch("order/getJob", this.order.id).then(data => {
        this.job = data;
        this.getEditsList(this.job.id);
      });
      this.getImages(this.order.id).then((data)=>{
        this.images = data;
      })
    },
    url(url) {
      return ASSET_DOMAIN + url;
    },
    submitDelete(edit) {
      this.deleteEdit(edit).then(({ data }) => {
        this.job = data;
      });
    },
    submitAddEdit() {
      this.addEdit({ jobId: this.job.id, editId: this.newLine }).then(
        ({ data }) => {
          this.job = data;
          this.addEditDialog = false;
          this.newLine = null;
        }
      );
    },
    hasOptions(editId) {
      return this.getOptions(editId) ? true : false;
    },
    getOptions(editId) {
      let options = null;
      let editObject = this.editsList.find(edit => edit.id == editId);
      if (editObject && editObject.options && editObject.options.length > 0) {
        return editObject.options;
      }
      return options;
    },
    submitAddOption(edit) {
      this.addOption({
        jobId: this.job.id,
        editId: edit.id,
        optionId: this.newOption.id,
        valueId: this.newOptionValue
      }).then(({ data }) => {
        this.job = data;
        this.addOptionDialog[edit.id] = false;
        this.newOption = null;
        this.newOptionValue = null;
      });
    },
    submitSent() {
      this.sent(this.job.id).then(({ data }) => {
        this.job = data;
        this.confirmSent = false;
      });
    },
    submitValidate() {
      this.confirm(this.order.id).then(() => {
        this.$emit("update");
        this.confirmValidate = false;
      });
    },
    shiftImage(id, newImage){
      this.changeImage({orderId:this.order.id, originalId:id, newImageId:newImage.id});
    },
    upload(){
      this.upload({files:[this.newImage]}).then((data)=>{
        this.images = data;
      })
    }
  }
};
</script>

<style>
</style>